import axios from 'axios'
import { environmentConfig } from '@/config/enviromentConfig'

const base = () => environmentConfig.integrationService
const ENTRY_TOKEN_TIMEOUT_MS = 5000

// service.telkom-integration. Subscriptions happen browser-to-Telkom; this service supplies the
// Evina kit, parks attribution, records the outcome and answers "already subscribed".
export default class IntegrationService {
  // POST /premium/intent -> { success, queued } — before /otp or /sub, keyed by ext_ref.
  static async recordIntent({ serviceId, extRef, msisdn, channel, transactionId, clickId, googleClickId, campaignId, publisherId, subPublisherId }) {
    const response = await axios.post(`${base()}/premium/intent`, {
      serviceId,
      extRef,
      msisdn: msisdn || undefined,
      channel,
      transactionId: transactionId || undefined,
      clickId: clickId || undefined,
      googleClickId: googleClickId || undefined,
      campaignId: campaignId || undefined,
      publisherId: publisherId || undefined,
      subPublisherId: subPublisherId || undefined
    })
    return response.data
  }

  // POST /premium/subscription -> { success, recorded, source: 'twt' | 'page', user } | { success: false, errorCode }
  static async recordPremiumSubscription({ serviceId, subscriptionId, transactionId, extRef, msisdn, channel = 'WAP', clickId, googleClickId, campaignId, publisherId, subPublisherId }) {
    const response = await axios.post(`${base()}/premium/subscription`, {
      serviceId,
      subscriptionId,
      transactionId,
      extRef,
      msisdn: msisdn || undefined,
      channel,
      clickId: clickId || undefined,
      googleClickId: googleClickId || undefined,
      campaignId: campaignId || undefined,
      publisherId: publisherId || undefined,
      subPublisherId: subPublisherId || undefined
    })
    return response.data
  }

  // POST /premium/evina/script -> { success, ti, token, script (base64) } | { success: false, skipped?, reason }
  static async getEvinaScript({ extRef, serviceId, msisdn, targetElement, cp }) {
    const response = await axios.post(`${base()}/premium/evina/script`, {
      extRef,
      serviceId,
      msisdn: msisdn || undefined,
      targetElement,
      cp: cp ? 1 : undefined
    })
    return response.data
  }

  // POST /premium/evina/check -> { allow, outcome: 'allow' | 'review' | 'block' | 'retry' | 'unverified' | 'skipped', ft, score }
  static async evinaCheck({ extRef, serviceId, msisdn }) {
    const response = await axios.post(`${base()}/premium/evina/check`, {
      extRef,
      serviceId,
      msisdn: msisdn || undefined
    })
    return response.data
  }

  // POST /premium/result -> { success, ready, result?, subscriptionId?, msisdn?, extRef? }: Telkom's outcome
  // for this ext_ref once its ACTIVE callback is in (the fields Telkom's welcome SMS puts on the portal link).
  static async getPremiumResult({ serviceId, extRef }) {
    const response = await axios.post(`${base()}/premium/result`, { serviceId, extRef })
    return response.data
  }

  static async getEntryToken({ serviceId, extRef, subscriptionId }) {
    const response = await axios.post(`${base()}/premium/entry-token`, { serviceId, extRef, subscriptionId }, { timeout: ENTRY_TOKEN_TIMEOUT_MS })
    return response.data
  }

  // POST /v2-get-user-via-product-id -> { success, user: { statusName, statusId, ... } | null }
  static async getUser(msisdn, productId) {
    const response = await axios.post(`${base()}/v2-get-user-via-product-id`, {
      msisdn,
      productId
    })
    return response.data?.user ?? null
  }
}
